import { render, staticRenderFns } from "./Deck.vue?vue&type=template&id=60269b77&scoped=true&"
import script from "./Deck.vue?vue&type=script&lang=js&"
export * from "./Deck.vue?vue&type=script&lang=js&"
import style0 from "./Deck.vue?vue&type=style&index=0&id=60269b77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60269b77",
  null
  
)

export default component.exports